// extracted by mini-css-extract-plugin
export default {"originsList":"originsList__t6557S","withMarginTop":"withMarginTop__FPu8Vp"};